import React, { Component } from 'react';
import { Card } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class CandleChart extends Component {
    constructor(props) {
        super(props);
        this.init = false;
        this.trades = {};
    }
    componentDidMount() {
        const store = this.props.store;
        const { currentUser } = store.userStore;

        this.widget = new window.TradingView.widget({
            //debug: true, // uncomment this line to see Library errors and warnings in the console
            fullscreen: false,
            symbol: this.props.symbol,
            interval: '15',
            container_id: 'chart',
            datafeed: {
                onReady(cb) {
                    cb();
                },

                resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
                    onSymbolResolvedCallback({
                        name: symbolName,
                        supported_resolutions: [
                            '1',
                            '3',
                            '5',
                            '15',
                            '30',
                            '60',
                            '120',
                            '240',
                            '360',
                            '720',
                            'D'
                        ],
                        has_intraday: true,
                        minmov: 1,
                        pricescale: symbolName === 'XRPUSD' ? 10000 : 10
                    });
                },
                getBars: async (
                    symbolInfo,
                    resolution,
                    from,
                    to,
                    onHistoryCallback,
                    onErrorCallback,
                    firstDataRequest
                ) => {
                    const candles = await store.odysseyBotStore.getKline(
                        symbolInfo.name,
                        resolution,
                        from,
                        to
                    );
                    onHistoryCallback(candles);
                },
                subscribeBars: async (
                    symbolInfo,
                    resolution,
                    onRealtimeCallback,
                    subscriberUID,
                    onResetCacheNeededCallback
                ) => {
                    store.odysseyBotStore.streamKline(symbolInfo.name, resolution);
                    store.odysseyBotStore.socket.on('kline', ({ data }) => {
                        onRealtimeCallback(data);
                    });
                },
                unsubscribeBars(subscriberUID) {
                    //noop
                }
            },

            library_path: '/charting_library/',
            locale: 'en',
            disabled_features: ['study_templates', 'header_symbol_search', 'header_compare'],
            enabled_features: [''],
            charts_storage_url: 'http://saveload.tradingview.com',
            charts_storage_api_version: '1.1',
            client_id: 'apextrader.io',
            user_id: currentUser.uid,
            autosize: true,
            theme: 'dark',
            load_last_chart: true
        });

        // this.widget.onChartReady(() => {
        //     this.widget.onContextMenu(function(unixtime, price) {
        //         const date = new Date(unixtime * 1000);
        //         return [
        //             {
        //                 position: 'top',
        //                 text:
        //                     'Create Trigger: ' +
        //                     date.toUTCString() +
        //                     ', Price: ' +
        //                     price.toFixed(2),
        //                 click: function() {
        //                     alert('First clicked.');
        //                 }
        //             }
        //         ];
        //     });
        // });
        this.init = true;
    }

    updateOrderLines(position, positionDetails, lastTrades) {
        if (!this.init) return;
        const store = this.props.store;

        try {
            this.widget.onChartReady(() => {
                if (this.entry && positionDetails) {
                    this.entry
                        .setText(`${positionDetails.side === 'BUY' ? 'LONG' : 'SHORT'} ENTRY`)
                        .setQuantity(positionDetails.qty)
                        .setPrice(positionDetails.avg_entry || positionDetails.entry_price);
                } else if (positionDetails) {
                    this.entry = this.widget
                        .chart()
                        .createPositionLine()
                        .setText(`${positionDetails.side === 'BUY' ? 'LONG' : 'SHORT'} ENTRY`)
                        .setQuantity(positionDetails.qty)
                        .setLineLength(3)
                        .setPrice(positionDetails.avg_entry || positionDetails.entry_price)
                        .setBodyBackgroundColor('#222437');
                }

                if (this.liquidation && position) {
                    this.liquidation.setQuantity(position.size).setPrice(position.liq_price);
                } else if (position) {
                    this.liquidation = this.widget
                        .chart()
                        .createPositionLine()
                        .setText('LIQUIDATION')
                        .setQuantity(position.size)
                        .setLineLength(3)
                        .setPrice(position.liq_price)
                        .setLineColor('#ff3366')
                        .setBodyBorderColor('#ff3366')
                        .setBodyTextColor('#ff3366')
                        .setQuantityBorderColor('#ff3366')
                        .setQuantityBackgroundColor('#ff3366')
                        .setBodyBackgroundColor('#222437');
                }

                if (positionDetails && position.size !== 0) {
                    if (positionDetails.stop_loss) {
                        if (this.stopLoss) {
                            this.stopLoss
                                .setQuantity(positionDetails.qty)
                                .setPrice(positionDetails.stop_loss);
                        } else {
                            this.stopLoss = this.widget
                                .chart()
                                .createOrderLine()
                                .setText('STOP LOSS')
                                .setQuantity(positionDetails.qty)
                                .setLineLength(3)
                                .setPrice(positionDetails.stop_loss)
                                .setLineColor('#ff3366')
                                .setBodyBorderColor('#ff3366')
                                .setBodyTextColor('#ff3366')
                                .setQuantityBorderColor('#ff3366')
                                .setQuantityBackgroundColor('#ff3366')
                                .setBodyBackgroundColor('#222437')
                                .onModify(function(data, cb) {
                                    //noop allows on move to work
                                })
                                .onMove(function() {
                                    store.odysseyBotStore.updateStopLossPrice(this.getPrice());
                                });
                        }
                    }

                    if (positionDetails.exit_price) {
                        if (this.exitPrice) {
                            this.exitPrice
                                .setQuantity(positionDetails.qty)
                                .setPrice(positionDetails.exit_price);
                        } else {
                            this.exitPrice = this.widget
                                .chart()
                                .createOrderLine()
                                .setText('TAKE PROFIT')
                                .setQuantity(positionDetails.qty)
                                .setLineLength(3)
                                .setPrice(positionDetails.exit_price)
                                .setLineColor('#29c0b1')
                                .setBodyBorderColor('#29c0b1')
                                .setBodyTextColor('#29c0b1')
                                .setQuantityBorderColor('#29c0b1')
                                .setQuantityBackgroundColor('#29c0b1')
                                .setBodyBackgroundColor('#222437')
                                .onModify(function(data, cb) {
                                    //noop allows on move to work
                                })
                                .onMove(function() {
                                    store.odysseyBotStore.updateTakeProfitPrice(this.getPrice());
                                });
                        }
                    }
                } else {
                    this.stopLoss && this.stopLoss.remove();
                    this.exitPrice && this.exitPrice.remove();
                }

                if (!positionDetails) {
                    this.entry && this.entry.remove();
                    this.stopLoss && this.stopLoss.remove();
                    this.exitPrice && this.exitPrice.remove();
                }

                lastTrades.forEach(trade => {
                    [...trade.entry_orders, ...trade.exit_orders]
                        .filter(order => order.order_status === 'Filled')
                        .forEach(order => {
                            if (this.trades[order._id]) return;

                            this.trades[order._id] = this.widget
                                .chart()
                                .createExecutionShape()
                                .setText(
                                    `${order.order_type} ${order.side} ${order.qty}@${order.last_exec_price}  `
                                )
                                .setTextColor(order.side === 'Buy' ? '#29c0b1' : '#ff3366')
                                .setArrowColor(order.side === 'Buy' ? '#29c0b1' : '#ff3366')
                                .setDirection(order.side.toLowerCase())
                                .setTime(parseInt(order.last_exec_time, 10))
                                .setPrice(parseFloat(order.last_exec_price));
                        });
                });
            });
        } catch (e) {
            console.log('Error in chart', e.stack);
        }
    }

    render() {
        const {
            position,
            positionDetails,
            activeTradingSessionTrades
        } = this.props.store.odysseyBotStore;
        this.updateOrderLines(position, positionDetails, activeTradingSessionTrades);
        return (
            <Card
                size={'small'}
                bordered={false}
                style={{ height: 700, marginBottom: 15 }}
                bodyStyle={{ height: '100%' }}
            >
                <div id="chart" style={{ height: '100%' }} />
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/TradeView/Chart.js